// The notice of a study draft bound to another revision than the active one (A27 (i)): the
// codes picked from that revision's diagram may not match this one, so the engineer decides -
// keep the draft as it is (it is bound to this revision from then on) or clear it. No picked
// code is ever removed silently.

export const OTHER_REVISION_DRAFT_NOTE =
  "This draft was started in another revision; codes picked from that revision's diagram " +
  "may not match this one.";

export function OtherRevisionDraftNotice({
  onKeep,
  onClear,
  disabled = false,
}: {
  onKeep: () => void;
  onClear: () => void;
  disabled?: boolean;
}) {
  return (
    <div role="status" data-other-revision-draft="true">
      <p>{OTHER_REVISION_DRAFT_NOTE}</p>
      <button type="button" disabled={disabled} onClick={onKeep}>
        Keep draft
      </button>
      <button type="button" disabled={disabled} onClick={onClear}>
        Clear draft
      </button>
    </div>
  );
}
